import type { IndustryContent } from '@/types/content';
import { getTestimonialsByIndustry } from '../testimonials';

export const applianceRepairContent: IndustryContent = {
  slug: 'appliance-repair',
  name: 'Appliance Repair',
  headline: 'The Operating System for Appliance Repair Companies',
  subheadline:
    'Diagnose faster, manage parts inventory, and fix it right the first time—all from one platform built for appliance pros.',
  heroImageUrl: '/images/industries/appliance-hero.webp',
  painPoints: [
    {
      title: 'Wrong parts, wasted trips',
      description:
        'Techs show up without the right compressor, board, or seal. Return visits kill your margins and frustrate customers.',
      icon: 'parts',
    },
    {
      title: 'Diagnosis takes too long',
      description:
        'Every brand, every model, different error codes. Techs spend too much time figuring out what\'s wrong.',
      icon: 'diagnosis',
    },
    {
      title: 'Parts inventory is a black hole',
      description:
        'You don\'t know what\'s in the warehouse, what\'s in the truck, or what\'s on order. Parts walk off and nobody notices.',
      icon: 'inventory',
    },
    {
      title: 'Warranty claims are a paperwork nightmare',
      description:
        'Manufacturer warranty work means forms, serial numbers, and photos. One mistake and you don\'t get paid.',
      icon: 'warranty',
    },
  ],
  features: [
    {
      title: 'Parts Inventory Management',
      description:
        'Track parts in warehouse and trucks in real-time. Know what you have, what you need, and what\'s on order.',
      icon: 'inventory',
    },
    {
      title: 'Diagnostic Guides',
      description:
        'Built-in troubleshooting guides by brand and model. Error code lookups and repair procedures at techs\' fingertips.',
      icon: 'diagnosis',
    },
    {
      title: 'Smart Dispatching',
      description:
        'Match jobs to techs based on skills, parts on truck, and location. Increase first-visit fix rates automatically.',
      icon: 'dispatch',
    },
    {
      title: 'Warranty Processing',
      description:
        'Capture all required documentation—serial numbers, photos, labor codes. Submit warranty claims directly from the app.',
      icon: 'warranty',
    },
    {
      title: 'Appliance History',
      description:
        'Track every appliance you\'ve serviced with complete repair history. Know what was done before you arrive.',
      icon: 'history',
    },
    {
      title: 'Flat Rate Pricing',
      description:
        'Present professional quotes on the spot. Good/better/best options help customers choose and increase ticket size.',
      icon: 'pricing',
    },
  ],
  testimonial: getTestimonialsByIndustry('appliance-repair')[0],
  stats: [
    { label: 'First-Visit Fix Rate', value: '92%' },
    { label: 'Parts Accuracy', value: '98%' },
    { label: 'Diagnosis Time', value: '-40%' },
    { label: 'Warranty Claim Approval', value: '95%' },
  ],
  seo: {
    title: 'Appliance Repair Software | Parts & Service Management | Omniforge',
    description:
      'Appliance repair software built for service companies. Parts inventory, diagnostic guides, warranty processing, and smart dispatch. Start your free trial.',
    keywords: [
      'appliance repair software',
      'appliance service software',
      'appliance business software',
      'appliance parts inventory',
      'appliance dispatch software',
      'appliance warranty management',
    ],
  },
};
